export enum TrackerMetricTypes {
  Numeric = 'numeric',
  Boolean = 'boolean',
  Select = 'select',
  Text = 'text',
  Photo = 'photo',
  Date = 'date',
  Duration = 'duration',
  Percentage = 'percentage',
}

export enum MetricNumericType {
  Basic = 'basic',
  Stepper = 'stepper',
  Range = 'range',
}
